<template>
  <div class="row">
    <user-menu></user-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_READ','ROLE_USER_ADMIN')">

      <toast ref="toast"></toast>

      <button v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')" class="btn btn-info m-2" @click="goNew"><i class="fa fa-child mr-1"></i>新規登録</button>
      <span class="form-group mr-3">
          <span style="margin-left:15px;">部署</span>
          <select class="search-select custom-select" name="department" v-model="selectedDepartmentId" @change="changeSelected">
            <option value="" selected="selected" v-if="hasAnyRole('ROLE_ADMIN', 'ROLE_MANAGE')">すべて</option>
            <option v-for="(current, index) in loginUser.departmentList" :value="loginUser.departmentIdList[index]" :key="index">
                    {{current}}
            </option>
          </select>
      </span>

      <label ref="viewAll"><input type="checkbox" id="viewAll" @click="checkUserView">退職者も表示</label>
      <button class="btn m-2" v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')" @click="retiree" style="background:#7592BA; border-radius:30px; color:#fff; float:right;" :class="{'retiree': retireeMode}">退職手続き</button>
      <p v-if="userList.length === 0">まだデータがありません</p>
      <table class="table table-bordered table-responsive">
            <thead class="thead-light">
              <tr>
                  <th>氏名</th>
                  <th>メール</th>
                  <th>部署</th>
                  <th>シフト</th>
                  <th>労働時間単位</th>
                  <th>権限</th>
                  <th>入社日</th>
                  <th>研修期間</th>
                  <th>有休発生日</th>
                  <th>緊急連絡先</th>
                  <!-- <th>Felica</th> -->
                  <th v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="result in userList" :key="result.userId" v-if="viewAll || result.deletedAt == null" :class="{'retiree': result.deletedAt}">
                  <td class="noflap">
                     <img class="card-img-top icon" :src="result.imageUrl ? result.imageUrl : ''" onerror="this.src='/src/assets/img/not_found_user_icon.jpg';">
                     <span v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')" class="noflap">
                        <a :href="'/admin/user/edit/' + result.userId">
                          {{result.userName}}
                        </a>
                     </span>
                     <span v-else class="noflap">{{result.userName}}</span>
                     <span v-if="result.birthday">({{result.birthday | age}})</span>
                  </td>
                  <td>{{result.mail}}</td>
                  <td >{{ result.unit && result.unit.length > 10 ? result.unit.slice(0,10) + '...' : result.unit }}</td>
                  <td>{{result.defaultWorkShiftName}}</td>
                  <td>{{result.defaultWorkTimeInterval}}</td>
                  <td>
                      <span v-if="result.roleName" v-for="role in result.roleName.split(',')" :key="role">
                          <span v-if="role.endsWith('神権限')" class="badge badge-primary" style="background-image: linear-gradient(to top left, #F7DE05, #DA8E00, #EDAC06, #F7DE05, #ECB802, #DAAF08, #B67B03);">{{role}}</span>
                          <span v-else-if="role.endsWith('フル権限')" class="badge badge-primary">{{role}}</span>
                          <span v-else-if="role.endsWith('管理') || role.endsWith('マネジメント権限')" class="badge badge-success">{{role}}</span>
                          <span v-else-if="!role.endsWith('管理') && !role.endsWith('フル権限')" class="badge badge-secondary">{{role}}</span>
                      </span>
                  </td>
                  <td class="noflap">{{result.hireDate}}</td>
                  <td class="noflap text-right">{{result.trainingMonth}}ヶ月</td>
                  <td class="noflap">{{result.yukyuStartDate}}</td>
                  <td>{{result.emergencyContact}}</td>
                  <!-- <td class="text-center"><span v-if="result.idm">◯︎</span></td> -->
                  <td v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">
                    <button v-if="result.userWorkRegistrationList.length == 0" type="button" class="btn btn-sm btn-outline-info" @click="goWorkRegistrarionCreate(result.userId)"><i class="fa fa-edit"></i>勤務登録</button>
                    <button v-else type="button" class="btn btn-sm btn-info" data-toggle="modal" :data-target="'#registration' + result.userId" @click="showRegistrarion(result.userId)"><i class="fa fa-book"></i>勤務登録</button>

                    <div class="modal fade" :id="'registration' + result.userId" tabindex="-1" role="dialog" aria-labelledby="exampleModal3Label" aria-hidden="true">
                      <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title mr-2" id="exampleModal3Label">勤務登録確認</h5>
                                <button type="button" class="btn btn-sm btn-outline-info" data-dismiss="modal" aria-label="Close" @click="goWorkRegistrarionCreate(result.userId)"><i class="fa fa-edit"></i>新規</button>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                              <user-work-registration-view-summary v-if="result.isRegistrationView" :result="result" :loginUser="loginUser"></user-work-registration-view-summary>
                            </div>
                        </div>
                      </div>
                    </div>
                    
                    <span v-if="result.userId != loginUser.userId">
                      <span v-if="retireeMode">
                        <button v-if="result.deletedAt == null" type="button" class="btn btn-sm btn-outline-info" data-toggle="modal" :data-target="'#retiree-modal-' + result.userId"><i class="fa fa-minus-circle"></i>退職</button>
                        <span v-else>{{result.deletedAt | date }} 退職済み</span>
                      </span>
                      <span v-else>
                        <button type="button" class="btn btn-sm btn-outline-danger" @click="deleteUser(result.userId)"><i class="fa fa-trash"></i>削除</button>
                      </span>
                    </span>

                    <!-- 退職日登録モーダル -->
                    <div class="modal fade" :id="'retiree-modal-' + result.userId" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">退職日を登録してください</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                </div>
                                <div class="modal-body">
                                    <form @submit.prevent="retireeUser(result.userId)">
                                        <div class="form-group">
                                            <label>氏名</label>
                                            <p>{{result.userName}}</p>
                                        </div>
                                        <div class="form-group">
                                            <label>退職日<span class="text-danger">*</span></label> <span v-if="!retireeDate" class="text-danger">日付を選んでください</span>
                                            <div>
                                                <el-date-picker v-model="retireeDate" type="date" placeholder="日付を選んでください" :class="{'border border-danger': !retireeDate}"></el-date-picker>
                                            </div>
                                        </div>
                                        <button type="submit" class="btn btn-primary">退職</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                  </td>
              </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
.retiree{
  background: #ccc !important;
}
.icon {
  border-radius: 50%;
  height: 45px;
  width: 45px;
}
.modal {
  overflow-y: auto;
  max-height: 95%;
}
</style>

<script>
import UserAPI from '../../../api/user-api'
import CommonAPI from '../../../api/common-api'
import Toast from '../../Toast.vue'
import UserMenu from './UserMenu.vue'
import UserWorkRegistrationViewSummary from '../../common/user/UserWorkRegistrationViewSummary.vue'

import moment from 'moment'

export default {
  name: "user-list",
  components: {
    Toast,
    UserMenu,
    UserWorkRegistrationViewSummary
  },
  data() {
    return {
      userList: [],
      loginUser: {
        role: ''
      },
      viewAll: false,
      retireeMode: false,
      selectedDepartmentId: '',
      retireeDate: moment().format("YYYY/MM/DD"),
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
      if(!this.hasAnyRole('ROLE_ADMIN', 'ROLE_MANAGE')){
          this.selectedDepartmentId = this.loginUser.departmentIdList.length > 0 ? this.loginUser.departmentIdList[0] : ''
      }
      this.getUserList()
    },
  },
  mounted () {
    if (this.$route.query.departmentId) {
        this.selectedDepartmentId = this.$route.query.departmentId
    }
  },
  methods: {
    getUserList() {
      this.$root.$refs.loading.$data.show = true
      let params = {
        departmentId: this.selectedDepartmentId,
      }
      UserAPI.getUserList(params)
            .then(res => {
              this.userList = res
              this.$nextTick(function() {
                this.$root.$refs.loading.$data.show = false
              })
            })
            .catch(err => {
              if(err.response.status === 403){
                this.$refs.toast.showToast("権限がありません", 3000, true)
                return false
              }
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
    },
    // 退職
    retireeUser (id) {
      if(!this.retireeDate){
        return
      }
      if (window.confirm('退職でよろしいですか?')){
        this.$root.$refs.loading.$data.show = true
        UserAPI.retireeUser(id, moment(this.retireeDate).format('YYYY-MM-DD'))
          .then(res => {
            this.getUserList()
            $(".close").click()
            this.$refs.toast.showToast("更新されました", 3000, false)
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
      }
    },
    // 削除
    deleteUser (id) {
      if (window.confirm('削除してよろしいですか?')){
        if (window.confirm('[注意]休暇申請、交通費、勤怠など紐づくすべてのデータが削除されます。')){
          this.$root.$refs.loading.$data.show = true
          UserAPI.deleteUser(id)
            .then(res => {
              this.getUserList()
              this.$refs.toast.showToast("削除しました", 3000, false)
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
        }
      }
    },
    goNew () {
        this.$router.push('/admin/user/new')
    },
    goEdit (id) {
        this.$router.push('/admin/user/edit/' + id)
    },
    goWorkRegistrarionCreate(userId) {
        this.$router.push('/admin/user/work-registration/edit/' + userId)
    },
    goWorkRegistrarion(id) {
        this.$router.push('/admin/user/work-registration/' + userId)
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser && this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    // 退職者も表示
    checkUserView() {
      this.viewAll = !this.viewAll
    },
    retiree() {
      this.retireeMode = !this.retireeMode
    },
    // セレクト変更時
    changeSelected () {
        // 履歴を追加
        this.$router.push("/admin/user/top/?departmentId=" + this.selectedDepartmentId)
        // データの再取得
        this.getUserList()
    },
    // 勤務登録表示
    showRegistrarion(userId){
      this.userList.forEach(function(user){
        if(user.userId == userId){
          user.isRegistrationView = true
          this.$forceUpdate();
        }
      }.bind(this))
    }
   },
  filters: {
    date: function (data) {
      return data ? moment(data).format("YYYY年MM月") : '';
    },
    dispInvalid: function (data) {
      return data ? '非表示' : '表示'
    },
    dispRole: function (date) {
      switch (date) {
        case 'ROLE_USER':
          return "一般";
          break;
        case 'ROLE_ADMIN':
          return "管理者";
          break;
        default:
          return "一般"
      }
    },
    age(data){
      if(data){
        return moment().diff(moment(data), "year");
      }
      return '';
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/user/UserList.vue